<template>
    <div class="mb-4 text-sm lh-140">
        <p class="lh-140">
            In order to <strong class="font-weight-bold">protect your account</strong>,
            make sure your password:
        </p>
        <ul class="pl-3">
            <li
                v-for="restrictionsItem in restrictionsList"
                :key="restrictionsItem"
                class="mb-1"
            >
                {{ restrictionsItem }}
            </li>
        </ul>
    </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
    name: "PasswordRestrictionsList",
    setup() {
        const restrictionsList = [
            "Password cannot be similar to the email or username",
            "Password cannot be entirely numerical",
            "Password cannot be too common (i.e., password123)",
            "Password must have a minimum of 8 characters",
        ];
        return {
            restrictionsList,
        };
    },
});
</script>
